var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "custom-control custom-switch" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.value,
          expression: "value"
        }
      ],
      staticClass: "custom-control-input",
      attrs: { type: "checkbox", id: _vm.property + _vm._uid },
      domProps: {
        checked: Array.isArray(_vm.value)
          ? _vm._i(_vm.value, null) > -1
          : _vm.value
      },
      on: {
        change: function($event) {
          var $$a = _vm.value,
            $$el = $event.target,
            $$c = $$el.checked ? true : false
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v)
            if ($$el.checked) {
              $$i < 0 && (_vm.value = $$a.concat([$$v]))
            } else {
              $$i > -1 &&
                (_vm.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.value = $$c
          }
        }
      }
    }),
    _vm._v(" "),
    _c(
      "label",
      {
        staticClass: "custom-control-label",
        attrs: { for: _vm.property + _vm._uid }
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$t("maintenance.activitySettings.model." + _vm.property)
            ) +
            "\n  "
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }